/**
 * Disables the button while the click handler is running.
 * Usage: use:busy={function}
 * @param node Auto-assigned by svelte compiler, should be a button
 * @param handler Async function to run when clicked.
 */
export function busy(
    node: HTMLButtonElement,
    handler: (e: MouseEvent) => Promise<any>
) {
    let currentHandler = handler;

    // @ts-ignore
    const onClick = async (e: MouseEvent) => {
        if (node.disabled) return;
        node.disabled = true;
        try {
            await currentHandler(e);
            node.disabled = false;
        } catch (error) {
            node.disabled = false;
            console.error("Error in asyncClick handler:", error);
        }
    };

    node.addEventListener('click', onClick);

    return {
        update(newHandler: typeof handler) {
            currentHandler = newHandler;
        },
        destroy() {
            node.removeEventListener('click', onClick);
        }
    };
}